<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div class="col mt-4 ms-lg-4">
                <h4>Edit Group Charges</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end add-btn me-4"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-none  d-sm-block"
                  type="button"
                  @click:button="BackToGroupCharges()"
                >
                  Back To Group Charges
                </llp-button>
                 <llp-button
                  classNames="btn-secondary new-btn d-block  d-sm-none"
                  @click:button="BackToGroupCharges()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
            <div class="row ms-lg-2">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="confirmPasswordLabel">Group Name:</llp-label>
                <llp-input
                  id="confirmpassword"
                  class="w-100"
                  autocomplete="off"
                  v-model="groupName"
                  disabled
                ></llp-input>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="role" :aria-label="Role">
                  Selected Role:
                </llp-label>
                <llp-input
                  id="confirmpassword"
                  class="w-100"
                  autocomplete="off"
                  v-model="selectedName"
                  disabled
                ></llp-input>
              </div>
            </div>

            <!-- Dynamic Tab Navigation -->
            <div class="row mt-4 ms-lg-4">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                  <a
                    class="nav-link"
                    :class="{ active: activeTab === tab.name.toLowerCase() }"
                    href="#"
                    @click.prevent="setActiveTab(tab.name.toLowerCase())"
                  >
                    {{ tab.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Dynamic Tab Content -->

            <div class="row mt-3 ms-lg-4"> 
                 <div v-if="loading" class="loader-overlay">
            <div class="spinner"></div>
                    </div>
              <div
                v-for="(tab, index) in tabs"
                :key="'content-' + index"
                v-show="activeTab === tab.name.toLowerCase()"
              >
                <div class="table-responsive col-lg-12 col-md-12 col-sm-12">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Method Type</th>
                        <th>Assign Charges (%)</th>
                        <!-- <th v-if="role_id == 2">Charges (%)</th> -->
                          <th>Charges (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(charge, i) in tab.charges" :key="i">
                        <td>{{ charge.name }}</td>

                        <!-- Editable: Assigned Charge -->
                        <td>
                          <llp-input
                            type="text"
                            v-model="charge.assignedCharge"
                            placeholder="Enter assigned charge (%)"
                           :disabled="role_id === '2' || role_id === '1'"

                          />
                        </td>

                        <!-- Editable: Original Charge -->
                        <td>
                          <llp-input
                            type="text"
                            v-model="charge.group_charges"
                            placeholder="Enter charge (%)"
                          />
                          <div
                            class="text-danger mt-1"
                            v-if="
                              validationErrors[tab.name.toLowerCase()] &&
                              validationErrors[tab.name.toLowerCase()][i]
                            "
                          >
                            {{ validationErrors[tab.name.toLowerCase()][i] }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary new-btn"
                @click="save()"
              >
                Save
              </llp-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>
<script>
import NetworkService from "@/services/network.service";
export default {
  data() {
    return {
      groupName: "",
      selectedRole: "",
      selectedName: "",
      activeTab: "cashfree",
      loading:false,
      tabs: [],
      validationErrors: {},
      role_id: localStorage.getItem("role_id"),
      selected_user_id: this.$route.params.id,
      user_id: localStorage.getItem("User_id"),
    };
  },
  mounted() {
    this.fetchingSelectGroupCharges();
  },

  methods: {
    BackToGroupCharges() {
      this.$router.push("/charges");
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },

    async fetchingSelectGroupCharges() {
      try {
      this.loading = true;
        const response = await NetworkService.get(
          `edit-charges-list/${this.selected_user_id}/${this.user_id}`
        );
        this.groupName = response.group.name;
        (this.selectedName = response.group.roles.name),
          (this.selectedRole = response.group.roles.id);
        // Tabs from payment_gateways array
        this.tabs = response.payment_gateways.map((gateway) => ({
          id: gateway.payment_gateway_id,
          name: gateway.payment_gateway_name,
          charges: gateway.charges.map((charge) => ({
            id: charge.master_charge_id,
            name: charge.payment_method,
            type: charge.type,
            assignedCharge: charge.master_charge_value || "",
            group_charges: charge.group_charge_value || "",
          })),
        }));
        if (this.tabs.length > 0) {
          this.activeTab = this.tabs[0].name.toLowerCase();
        }
        this.loading = false;
      } catch (error) {
         this.loading = false;
        this.$refs.toast.show("Unable to fetch the user charges.", "error");
      }
    },


// async save() {
//   this.showaddadminSpinner = true;
//   let hasError = false;
//   this.validationErrors = {};

//   for (const tab of this.tabs) {
//     const tabErrors = {};
//     for (let i = 0; i < tab.charges.length; i++) {
//       const charge = tab.charges[i];
      
//       if (this.role_id === "1") {
//         // Superadmin validation for assigned charges
//         const assigned = parseFloat(charge.assignedCharge);
//         if (isNaN(assigned)) {
//           tabErrors[i] = "Please enter a valid number for charge percentage.";
//           hasError = true;
//         } else if (assigned < 0) {
//           tabErrors[i] = "Charge percentage cannot be negative.";
//           hasError = true;
//         }
//       } else if (this.role_id === "2") {
//         const assigned = parseFloat(charge.assignedCharge);
//         const actual = parseFloat(charge.group_charges);
//         if (isNaN(actual)) {
//           tabErrors[i] = "Please enter a valid number for charge percentage.";
//           hasError = true;
//         } else if (actual < 0) {
//           tabErrors[i] = "Charge percentage cannot be negative.";
//           hasError = true;
//         } else if (!isNaN(assigned) && actual < assigned) {
//           tabErrors[i] = `Your charges cannot be less than the assigned charge (${assigned}%).`;
//           hasError = true;
//         }
//       }
//     }

//     if (Object.keys(tabErrors).length > 0) {
//       this.validationErrors[tab.name.toLowerCase()] = tabErrors;
//     }
//   }

//   if (hasError) {
//     this.showaddadminSpinner = false;
//     const activeTabErrors = this.validationErrors[this.activeTab];
//     if (activeTabErrors && Object.keys(activeTabErrors).length > 0) {
//       this.$refs.toast.show(
//         `Please correct the highlighted charges in the ${this.activeTab} tab.`, 
//         "error"
//       );
//     }
//     return;
//   }

//   try {
//     // Prepare the payload according to backend expectations
//     const payload = {
//       name: this.groupName,
//       role_id: this.selectedRole,
//       user_id: this.user_id,
//       charges: this.tabs.flatMap((tab) =>
//         tab.charges.map((charge) => ({
//           pg_name: tab.name,
//           pg_id: tab.id,
//           payment_method: charge.name,
//           type: charge.type,
//           // charge: this.role_id === "1" ? charge.assignedCharge : charge.group_charges,
//           charge:  charge.group_charges,

//           master_charge_id: charge.id // Include if backend needs it
//         }))
//       ),
//     };

//     const response = await NetworkService.post(
//       `/update-charges-list/${this.selected_user_id}`,
//       payload
//     );

//     if (response.data && response.data.status === false) {
//       throw new Error(response.data.message || "Update failed");
//     }

//     this.$refs.toast.show("Group charges updated successfully!");
//     setTimeout(() => {
//       this.BackToGroupCharges();
//     }, 2000);
//   } catch (error) {
//     console.error("Update error:", error);
//     this.$refs.toast.show(
//       error.response?.data?.message || 
//       error.message || 
//       "Failed to update group charges. Please try again.",
//       "error"
//     );
//   } finally {
//     this.showaddadminSpinner = false;
//   }
// }


async save() {
  this.showaddadminSpinner = true;
  let hasError = false;
  this.validationErrors = {};

  for (const tab of this.tabs) {
    const tabErrors = {};
    for (let i = 0; i < tab.charges.length; i++) {
      const charge = tab.charges[i];
      const assigned = parseFloat(charge.assignedCharge);
      const actual = parseFloat(charge.group_charges);
      
      
      if (isNaN(actual)) {
        tabErrors[i] = "Please enter a valid number for charge percentage.";
        hasError = true;
      } else if (actual < 0) {
        tabErrors[i] = "Charge percentage cannot be negative.";
        hasError = true;
      }
      
      // Role-specific validations
      if (this.role_id === "1") {
        if (isNaN(assigned)) {
          tabErrors[i] = "Please enter a valid number for assigned charge percentage.";
          hasError = true;
        } else if (assigned < 0) {
          tabErrors[i] = "Assigned charge percentage cannot be negative.";
          hasError = true;
        } else if (actual < assigned) {
          tabErrors[i] = `Charges (%) cannot be less than the assigned charge (${assigned}%).`;
          hasError = true;
        }
      } else if (this.role_id === "2") { // Admin
        if (!isNaN(assigned) && actual < assigned) {
          tabErrors[i] = `Your charges cannot be less than the assigned charge (${assigned}%).`;
          hasError = true;
        }
      }
    }

    if (Object.keys(tabErrors).length > 0) {
      this.validationErrors[tab.name.toLowerCase()] = tabErrors;
    }
  }

  if (hasError) {
    this.showaddadminSpinner = false;
    return;
  }

  try {
    const payload = {
      name: this.groupName,
      role_id: this.selectedRole,
      user_id: this.user_id,
      charges: this.tabs.flatMap((tab) =>
        tab.charges.map((charge) => ({
          pg_name: tab.name,
          pg_id: tab.id,
          payment_method: charge.name,
          type: charge.type,
          charge: charge.group_charges,
          master_charge_id: charge.id
        }))
      ),
    };

    const response = await NetworkService.post(
      `/update-charges-list/${this.selected_user_id}`,
      payload
    );

    if (response.data && response.data.status === false) {
      throw new Error(response.data.message || "Update failed");
    }

    this.$refs.toast.show("Group charges updated successfully!");
    setTimeout(() => {
      this.BackToGroupCharges();
    }, 2000);
  } catch (error) {
    console.error("Update error:", error);
    this.$refs.toast.show(
      error.response?.data?.message || 
      error.message || 
      "Failed to update group charges. Please try again.",
      "error"
    );
  } finally {
    this.showaddadminSpinner = false;
  }
}
  },
};
</script>

<style scoped>
.loader-overlay{
  position: relative;
  top: 60px;
}
</style>